export default "\n{% block sw_overlay %}\n<div class=\"sw-overlay\"></div>\n{% endblock %}\n";